import * as React from "react";
import { useMemo } from "react";
import RetrievalContext from "data-lake/preview/contexts/RetrievalContext";
import { INTERNAL_DATA_LAKE_TYPE } from "data-lake/Constants";
const bulkRetrievePayload = (messages, dataLakeId, payload) => ({
  messages,
  data_lake_id: dataLakeId,
  type: INTERNAL_DATA_LAKE_TYPE,
  stream_id: payload.sourceId,
  timeout: void 0
});
const RetrievalProvider = ({ children }) => {
  const contextValue = useMemo(() => ({ bulkRetrievePayload }), []);
  return /* @__PURE__ */ React.createElement(RetrievalContext.Provider, { value: contextValue }, children);
};
export default RetrievalProvider;
